/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RequiresToothDetails/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function RequiresToothDetails({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/Content/Content/Charge/RequiresToothDetails"
  
}) {
let chargeRequiresToothDetailsValueData = fromData.useDataFormat({ viewPath,
context: 'charge',
path: 'requires_tooth_details',
format: fromFormat.booleanToYesNo,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="charge.requires_tooth_details"
 format="/Data/format.js booleanToYesNo"
 text={chargeRequiresToothDetailsValueData}
 size="small"
/>
{children}
</React.Fragment>)
}